import React, {Suspense} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import store, {history} from '@/store';
import {ConnectedRouter} from 'connected-react-router';
import {ToastContainer} from 'react-toastify';
import {Helmet} from 'react-helmet-async';

// redux
import {Provider, useSelector} from "react-redux";

import Layout from '@/layouts';
import PageLoading from '@/components/page-loading';

import {I18nextProvider, useTranslation} from 'react-i18next';

// multi language
import i18n from '@/locales/i18n';

// load app SCSS styles
import '@/styles/App.scss';

// mui
import {Box} from "@mui/material";
import BackDrop from "@/components/backdrop/BackDrop";
import {selectBackdrop} from "@/store/slices/appSlice";

const ReactApp: React.FC = () => {
    const {t} = useTranslation()

    const openBackdrop: boolean = useSelector(selectBackdrop);
    //console.log('openBackdrop', openBackdrop);
    
    return (
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <Router basename={`${process.env.BASENAME}`}>
                    <Helmet titleTemplate="%s - Facturando" defaultTitle="Facturando">
                        <meta name="description" content="Facturando application"/>
                    </Helmet>
    
                    <ConnectedRouter history={history}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Suspense fallback={<PageLoading show/>}>
                                <BackDrop open={openBackdrop} text={t("common.refresh")} full/>
                                <Layout/>
                                <PageLoading/>
                            </Suspense>
                        </Box>
                    </ConnectedRouter>
    
                    <ToastContainer/>
                </Router>
            </I18nextProvider>
        </Provider>
    );
};

export default ReactApp;
